module.exports = __webpack_public_path__ + "static/media/GregBloedorn.1ff76e21.jpg";